var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeBuilderTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C9.76142 14 12 11.7614 12 9C12 6.23858 9.76142 4 7 4C4.23858 4 2 6.23858 2 9C2 11.7614 4.23858 14 7 14ZM5.5 8.25H8.5C8.91421 8.25 9.25 8.58579 9.25 9C9.25 9.41421 8.91421 9.75 8.5 9.75H5.5C5.08579 9.75 4.75 9.41421 4.75 9C4.75 8.58579 5.08579 8.25 5.5 8.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4274 21.5109L15.001 14.5516C14.9748 14.1243 15.4578 13.8512 15.8224 14.087L21.7616 17.9284C22.159 18.1855 22.0359 18.7856 21.568 18.8722L18.6193 19.4186C18.5013 19.4404 18.3943 19.5009 18.3159 19.5902L16.3586 21.8186C16.048 22.1722 15.456 21.9766 15.4274 21.5109Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2818 14.5381C20.9354 13.2578 22 11.2532 22 9C22 5.13401 18.866 2 15 2C13.3231 2 11.7839 2.58964 10.5785 3.57289C12.3387 4.7359 13.5 6.73234 13.5 9C13.5 11.2677 12.3387 13.2641 10.5785 14.4271C11.4337 15.1247 12.4568 15.6241 13.5779 15.8555L13.5036 14.6432C13.3983 12.9252 15.2922 11.9577 16.6368 12.8274L19.2818 14.5381ZM14.75 9C14.75 8.58579 15.0858 8.25 15.5 8.25H18.5C18.9142 8.25 19.25 8.58579 19.25 9C19.25 9.41421 18.9142 9.75 18.5 9.75H15.5C15.0858 9.75 14.75 9.41421 14.75 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeBuilderTool);
export default __webpack_public_path__ + "static/media/shape-builder-tool.7dbb332d25a5dff8eec238af6f581ba6.svg";
export { ForwardRef as ReactComponent };